import React from 'react';
import classNames from 'classnames';

import css from './IconCloset.module.css';

/**
 * IconCloset icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconCloset = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes}
    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10.9291 0H4.28627C3.60429 0 2.95023 0.270918 2.468 0.753154C1.98576 1.23539 1.71484 1.88944 1.71484 2.57143V21.4286C1.71484 22.1106 1.98576 22.7646 2.468 23.2468C2.95023 23.7291 3.60429 24 4.28627 24H10.9291V0ZM13.072 24H19.7148C20.3968 24 21.0509 23.7291 21.5331 23.2468C22.0154 22.7646 22.2863 22.1106 22.2863 21.4286V2.57143C22.2863 1.88944 22.0154 1.23539 21.5331 0.753154C21.0509 0.270918 20.3968 0 19.7148 0L13.072 0V24ZM16.2863 10.0063C16.8777 10.0063 17.3577 10.4863 17.3577 11.0777V12.9223C17.3577 13.063 17.33 13.2023 17.2761 13.3323C17.2223 13.4623 17.1434 13.5804 17.0439 13.6799C16.9444 13.7794 16.8263 13.8583 16.6963 13.9122C16.5663 13.966 16.427 13.9937 16.2863 13.9937C16.1456 13.9937 16.0062 13.966 15.8763 13.9122C15.7463 13.8583 15.6281 13.7794 15.5287 13.6799C15.4292 13.5804 15.3502 13.4623 15.2964 13.3323C15.2426 13.2023 15.2148 13.063 15.2148 12.9223V11.0777C15.2148 10.4846 15.6948 10.0063 16.2863 10.0063ZM8.78627 11.0777C8.78627 10.7936 8.67339 10.521 8.47246 10.3201C8.27153 10.1192 7.999 10.0063 7.71484 10.0063C7.43068 10.0063 7.15816 10.1192 6.95723 10.3201C6.7563 10.521 6.64342 10.7936 6.64342 11.0777V12.9223C6.64342 13.2064 6.7563 13.479 6.95723 13.6799C7.15816 13.8808 7.43068 13.9937 7.71484 13.9937C7.999 13.9937 8.27153 13.8808 8.47246 13.6799C8.67339 13.479 8.78627 13.2064 8.78627 12.9223V11.0777Z" fill="#262338"/>
</svg>
  );
};

export default IconCloset;
